import { createRouter, createWebHistory, } from "vue-router";

import store from "../store";
import api from "../request";
import utils from "../utils";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
NProgress.configure({
  easing: "ease", // 动画方式
  speed: 500, // 递增进度条的速度
  showSpinner: false, // 是否显示加载ico
  trickleSpeed: 200, // 自动递增间隔
  minimum: 0.3, // 初始化时的最小百分比
});

import Login from "@/views/login.vue";
import NotFound from "@/views/404.vue";
//0.首页
import home from "@/views/home.vue";

//1. 电商数据管理
//1.1 订单管理
import data_order from "@/views/order/index.vue";
//1.2 采购管理
import data_purchase from "@/views/purchase/index.vue";
//1.3 库存管理
import data_inventory from "@/views/inventory/index.vue";
//1.4 物流单管理
import data_logistics from "@/views/logistics/index.vue";
//1.5 收款明细管理
import data_trade from "@/views/trade/index.vue";
//1.6 授权店铺信息
import data_stores from "@/views/stores/index.vue";

//2. 财务管理
//2.1 授信管理
import finance from "@/views/finance/index.vue";
//2.2 放款管理
import finance_payment from "@/views/finance/payment.vue";
//2.3 还款管理
import finance_repayment from "@/views/finance/repayment.vue";
//2.4 回款管理
import finance_interest from "@/views/finance/interest.vue";
//2.5 结算管理
import finance_settle from "@/views/finance/settle.vue";
//2.6 项目财务报表
import finance_report from "@/views/finance/report.vue";

//3. 供应商管理
//3.1 供应商列表
import supplier from "@/views/supplier/index.vue";

//4. 代付管理
//4.1 代付申请
import payanother from "@/views/paymanage/payanother.vue";
//4.2 代付统计
import paymanage_statics from "@/views/paymanage/statics.vue";

//5. 合同管理
//5.1 代收合同
import contract_receive from "@/views/contract/receive.vue";
//5.2 代付合同
import contract_pay from "@/views/contract/pay.vue";

//6. 商户管理
//6.1 ERP商户
import orglist from "@/views/org/list.vue";
//6.2 平台账户
import orgaccounts from "@/views/org/accounts.vue";
//6.3 商户团队
import orgteams from "@/views/org/teams.vue";
//7. 账号管理
import account from "@/views/account/index.vue";
import timeborad from "@/views/account/timeboardnew.vue";
import erpnews from "@/views/account/erpnews.vue";
const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    component: home,
    meta: { layout: "basic-layout" },
  },
  //电商数据管理
  {
    path: "/data",
    redirect: "/data/order",
  },
  //订单管理
  {
    path: "/data/order",
    component: data_order,
    meta: { layout: "basic-layout" },
  },
  //采购管理
  {
    path: "/data/purchase",
    component: data_purchase,
    meta: { layout: "basic-layout" },
  },
  //库存管理
  {
    path: "/data/inventory",
    component: data_inventory,
    meta: { layout: "basic-layout" },
  },
  //物流运单管理
  {
    path: "/data/logistics",
    component: data_logistics,
    meta: { layout: "basic-layout" },
  },
  //收款明细管理
  {
    path: "/data/trade",
    component: data_trade,
    meta: { layout: "basic-layout" },
  },
  //授权店铺信息
  {
    path: "/data/stores",
    component: data_stores,
    meta: { layout: "basic-layout" },
  },
  //财务管理
  {
    path: "/finance",
    redirect: "/finance/index",
  },
  //授信管理
  {
    path: "/finance/index",
    component: finance,
    meta: { layout: "basic-layout" },
  },
  //放款管理
  {
    path: "/finance/payment",
    component: finance_payment,
    meta: { layout: "basic-layout" },
  },
  //还款管理
  {
    path: "/finance/repayment",
    component: finance_repayment,
    meta: { layout: "basic-layout" },
  },
  //利息管理
  {
    path: "/finance/interest",
    component: finance_interest,
    meta: { layout: "basic-layout" },
  },
  //结算管理
  {
    path: "/finance/settle",
    component: finance_settle,
    meta: { layout: "basic-layout" },
  },
   //项目财务报表
  {
    path: "/finance/report",
    component: finance_report,
    meta: { layout: "basic-layout" },
  },
  //供应商管理
  {
    path: "/supplier",
    redirect: "/supplier/index",
  },
  //供应商列表
  {
    path: "/supplier/index",
    component: supplier,
    meta: { layout: "basic-layout" },
  },
  //代付管理
  {
    path: "/paymanage",
    redirect: "/paymanage/payanother",
  },
  //代付申请
  {
    path: "/paymanage/payanother",
    component: payanother,
    meta: { layout: "basic-layout" },
  },
  //代付统计
  {
    path: "/paymanage/statics",
    component: paymanage_statics,
    meta: { layout: "basic-layout" },
  },
  //合同管理
  {
    path: "/contract",
    redirect: "/contract/receive",
  },
  //代收合同
  {
    path: "/contract/receive",
    component: contract_receive,
    meta: { layout: "basic-layout" },
  },
  //代付合同
  {
    path: "/contract/pay",
    component: contract_pay,
    meta: { layout: "basic-layout" },
  },
  ///商户管理
  {
    path: "/org",
    redirect: "/org/list",
  },
  //ERP商户
  {
    path: "/org/list",
    component: orglist,
    meta: { layout: "basic-layout" },
  },
  //平台账户
  {
    path: "/org/accounts",
    component: orgaccounts,
    meta: { layout: "basic-layout" },
  },
  //商户团队
  {
    path: "/org/teams",
    component: orgteams,
    meta: { layout: "basic-layout" },
  },
  ///账号管理
  {
    path: "/account",
    component: account,
    meta: { layout: "basic-layout" },
  },
  ///计划管理
  {
    path: "/account/timeboardnew",
    component: timeborad,
    meta: { layout: "basic-layout" },
  },
   ///事件管理
  {
    path: "/account/erpnews",
    component: erpnews,
    meta: { layout: "basic-layout" },
  },
  //登录
  {
    path: "/login",
    component: Login,
    meta: { layout: "empty-layout", requireAuth: false },
  },
  //404
  {
    path: "/:catchAll(.*)",
    component: NotFound,
    meta: { layout: "empty-layout", requireAuth: false },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_PATH),
  routes: routes,
});
window._doRouterPush = (path) => {
  // if (router.currentRoute.path === path) return;
  router.push({ path }).catch(console.error);
};
window._doRouterReplace = (path) => {
  // if (router.currentRoute.path === path) return;
  router.replace({ path }).catch(console.error);
};
router.beforeEach((to, from, next) => {
  NProgress.start(); // 路由跳转前钩子函数中 - 执行进度条开始加载
  let v = localStorage.getItem("zbsc_admin.version") || "0";
  api.get(`/api/admin/init?t=${Date.now()}&v=${v}`).then((data) => {
    // console.log(data);
    NProgress.done();
    if (data.code === "newversion") {
      localStorage.setItem("zbsc_admin.version", data.version);
      window._doRouterPush(to.fullPath);
      return;
    }
    setTimeout(async () => {
      let { userid = "", username = "", name = "", role = "", utype = "", needlogin } = data.data;
      await utils.setStore({ userid, username, name, role, utype });
      if (needlogin) localStorage.clear();
      if (!localStorage.getItem("zbsc_admin.token") && to.meta?.requireAuth !== false) {
        return next({ path: '/login' });
      }
      if (localStorage.getItem("zbsc_admin.token") && to.path === "/login") {
        return next({ path: "/" });
      }
      next();
    }, 0);
  }).catch((e) => {
    NProgress.done();
    console.error(e);
  });
});
router.afterEach(() => {
  // 在即将进入新的页面组件前，关闭掉进度条
  NProgress.done();
});

export default router;
